module.exports = __webpack_public_path__ + "static/media/waze_image.2af95780.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/waze_image.png
// module id = 75
// module chunks = 0